import { i18nLocizeInstance } from '@influitive/locize-launcher';

const i18n = options => i18nLocizeInstance(process.env.LOCIZE_PROJECT_ID, process.env.LOCIZE_API_KEY, options);

export default i18n;
